
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class PDCReceivableDialog extends Serenity.EntityDialog<PDCReceivableRow, any> {
        protected getFormKey() { return PDCReceivableForm.formKey; }
        protected getIdProperty() { return PDCReceivableRow.idProperty; }
        protected getLocalTextPrefix() { return PDCReceivableRow.localTextPrefix; }
        protected getNameProperty() { return PDCReceivableRow.nameProperty; }
        protected getService() { return PDCReceivableService.baseUrl; }
        protected getDeletePermission() { return PDCReceivableRow.deletePermission; }
        protected getInsertPermission() { return PDCReceivableRow.insertPermission; }
        protected getUpdatePermission() { return PDCReceivableRow.updatePermission; }

        protected form = new PDCReceivableForm(this.idPrefix);
        constructor() {
            super();
            q.setTextRightAlign(this.form.Amount);
            q.setTextRightAlign(this.form.ChequeNo);
        }
    }
}